import Icon from '../components/Icon.vue'

Icon.register({
  'house-user': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M570.7 236.3c2.9 3.2 4.8 7.4 5.3 11.9-0.4 4-1.9 7.6-4.1 10.7l-21.4 23.8c-3.2 2.9-7.3 4.8-11.9 5.3-4-0.4-7.7-1.9-10.7-4.1l-15.9-14v210.1c0 17.7-14.3 32-32 32h-383.9c-17.7 0-32-14.3-32-32v-210.1l-15.9 14c-3 2.2-6.7 3.7-10.7 4.1-4.6-0.5-8.8-2.4-12-5.3l-21.4-23.8c-2.4-3-3.9-6.7-4.1-10.7 0.2-4.6 2.2-8.8 5.3-11.9l256-226c6.3-5.7 18.2-10.3 26.7-10.3s20.5 4.6 26.8 10.3l101.2 89.4v-51.7c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v136.4zM288 176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zM400 448c8.8 0 16-7.2 16-16 0-53-43-96-96-96h-64c-53 0-96 43-96 96 0 8.8 7.2 16 16 16h224z'
      }
    ]
  }
})
